const tags = document.querySelectorAll('.all.tags .tag');
const pageBlog = document.querySelector('.page.page-blog');
const allBLogHeadings = document.querySelectorAll('.page.page-blog .card .p-3.heading');
const allArticles = document.querySelectorAll('.all-articles');

if (tags.length) {
    const div = document.createElement('div');
    document.body.appendChild(div);
  	let prevActive;
    tags.forEach(tag => {
        tag.addEventListener('click', () => {
                             
			if(prevActive) {
          		prevActive.classList.remove('active');
        	}
      		tag.classList.add('active');
      		prevActive = tag;
            pageBlog.style.opacity = 0;
			const parentContainer = document.querySelectorAll('.parent-container');

             setTimeout(() => {
                parentContainer.forEach(parent => {
                    const articles = parent.querySelector(`.all-articles.${tag.dataset.tag}`);
                    if(articles) {
                        parent.classList.remove('d-none');
                    } else {
                     parent.classList.add('d-none'); 
                    }
                })                        
                div.innerHTML = `
                <style>
                            .all-articles.${tag.dataset.tag} {
                                display: block;
                            }
                </style>`
                pageBlog.style.opacity = 1;
            }, 500);
        })
    })
    tags[0].click();

    setTimeout(() => {
      let minHeight = allBLogHeadings[0].offsetHeight;

      allBLogHeadings.forEach(heading => {
          minHeight = heading.offsetHeight > minHeight ? heading.offsetHeight : minHeight; 
      });

      allBLogHeadings.forEach(heading => {
        heading.style.height = minHeight + 'px';
      });
	}, 1000)
}

const blogOpener = document.querySelector('.blog-bottom-slider');
const newsletterPopup = document.querySelector('.newsletter-popup');
const newsletterPopupCloser = document.querySelector('.newsletter-inner button.popup-closer');
if(blogOpener) {
  blogOpener.addEventListener('click', () => {
		newsletterPopup.classList.add('active');
  }) 
  
  newsletterPopupCloser.addEventListener('click', () => {
		newsletterPopup.classList.remove('active');
  })   
}